import { Typography } from "@mui/material";

export default function Goals() {
  return <Typography>Admin Goals Page</Typography>;
}
